import { findInventoryInstanceNode, resolveCachedItemForRender } from './find-cached-item';
import { refuseUnported } from '../janus-engine/unported.js';
import type { ObjectManipulationPlan, ObjectManipulationRequest } from '../janus-engine/actions/object-manipulation-bridge.js';
import type { ObjectManipulationReceipt, ObjectManipulationVerb } from '../janus-engine/actions/object-manipulation-gate.js';

function bridge() {
    const truth = window.ftObjectManipulationTruth;
    truth?.registerInventoryReaders({ findInventoryInstanceNode, resolveCachedItemForRender });
    return truth;
}

export function ftObjectManipulationPlan(inventoryId: string, verb: ObjectManipulationVerb): ObjectManipulationPlan {
    return bridge()?.plan(inventoryId, verb) ?? {
        ok: false, reason: 'object-manipulation-truth-not-held', actorId: '', inventoryId, verb,
        actorOrigin: null, objectOrigin: null, pickupOnly: false, approachRequired: false, approachDestination: null,
    };
}

export function ftObjectManipulationStart(inventoryId: string, verb: ObjectManipulationVerb): boolean {
    const truth = bridge();
    if (truth) return truth.start(inventoryId, verb);
    refuseUnported('object-' + verb + ':object-manipulation-truth-not-held', { inventoryId });
    return false;
}

export function ftObjectManipulationPreview(input: ObjectManipulationRequest) {
    return bridge()?.preview(input) ?? { ok: false as const, reason: 'object-manipulation-truth-not-held' };
}

export async function ftObjectManipulationCommit(input: ObjectManipulationRequest): Promise<ObjectManipulationReceipt> {
    const truth = bridge();
    if (truth) return truth.commit(input);
    throw new Error(refuseUnported('object-' + input.verb + ':object-manipulation-truth-not-held',
        { inventoryId: input.inventoryId, actorId: input.actorId }).reason);
}

export function ftApplyObjectManipulationReceipt(receipt: ObjectManipulationReceipt): void {
    bridge()?.applyReceipt(receipt);
}

// Keep the established page/iframe entry points while all mutable action state belongs to websocket.
bridge();
Object.assign(window, { ftObjectManipulationPlan, ftObjectManipulationStart, ftObjectManipulationPreview,
    ftObjectManipulationCommit, ftApplyObjectManipulationReceipt });
